module.exports = __webpack_public_path__ + "static/AzoSans-Medium-1d3285d561016b328a35396496242872.woff";